import { SVGProps } from 'react';

const ChevronsDownUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m7 20 5-5 5 5M7 4l5 5 5-5"
    />
  </svg>
);
export default ChevronsDownUp;
